import { Injectable } from '@angular/core';
import { DataService } from 'app/shared/services/data.service';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { Observable } from 'rxjs';
import { ISelect } from 'app/shared/models/select.model';
import { map } from 'rxjs/operators';
import { IDtoEmployee } from 'app/shared/models/employee/dto-employee.model';
import { IResult } from 'app/shared/models/result.model';
import { IDtoInability } from 'app/shared/models/request/inability/dto-inability.model';
import { IDtoInabilityFilter } from 'app/shared/models/request/inability/dto-inability-filter.model';
import { IDtoDocument } from 'app/shared/models/request/dto-document.model';

@Injectable()
export class InabilityService {
    private requestUrl = '';
    private recruitmentUrl = '';
    constructor(private service: DataService, private configurationService: ConfigurationService) {
        if (this.configurationService.isReady) {
            this.requestUrl = this.configurationService.serverSettings.requestUrl;
            this.recruitmentUrl = this.configurationService.serverSettings.recruitmentUrl;
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.requestUrl = this.configurationService.serverSettings.requestUrl;
                this.recruitmentUrl = this.configurationService.serverSettings.recruitmentUrl;
            });
        }
    }
    public getCatalogLineInsurances(): Observable<ISelect[]> {
        const url = `${this.requestUrl}api/Inabilities/getLineInsurance/`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogTypeRisks(lineInsuranceId: string): Observable<ISelect[]> {
        const url = `${this.requestUrl}api/Inabilities/getTypeRisk?lineInsuranceId=${lineInsuranceId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogLingeringIssuesKeys(typeRiskId: string): Observable<ISelect[]> {
        const url = `${this.requestUrl}api/Inabilities/getLingeringIssuesKey?typeRiskId=${typeRiskId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogInabilityControlKey(lingeringIssuesKeyId: string): Observable<ISelect[]> {
        const url = `${this.requestUrl}api/Inabilities/getInabilityControlKey?lingeringIssuesKeyId=${lingeringIssuesKeyId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
  public getListEmployeeActive(): Observable<IDtoEmployee[]> {
    const url = `${this.recruitmentUrl}api/Employees/getListEmployeesActives`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                     return res;
                })
            );
  }
  public getListActiveEmployeesByBossId(bossId: string): Observable<IDtoEmployee[]> {
    const url = `${this.recruitmentUrl}api/Employees/getListActiveEmployeesByBossId?bossId=${bossId}`;
         return this.service.get(url)
            .pipe(
                map((res: any) => {
                     return res;
                 })
      );
  }   
    public addInability(inability: IDtoInability): Observable<IResult> {
        const url =`${this.requestUrl}api/Inabilities/`;
        return this.service.post(url, inability).pipe(map((response: any) => {
            return response;
        }));
    }
    public getInabilitiesbyFilters(data: IDtoInabilityFilter): Observable<IResult> {
        const url =`${this.requestUrl}api/Inabilities/getInabilitiesbyFilter/`;
        return this.service.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public uploadFile(item: IDtoInability, fileToUpload: File): Observable<IResult> {
        const formData = new FormData();
        formData.append('inability', JSON.stringify(item));
        formData.append('files', fileToUpload);

        const url = `${this.requestUrl}api/InabilityDocuments/uploadFile/`;
        return this.service.post(url, formData).pipe(map((response: any) => {
            return response;
        }));
    }
    public downloadFile(documentId: number): Observable<IResult> {

        const url = `${this.requestUrl}api/InabilityDocuments/downloadFile?inabilityDocumentId=${documentId}`;
        return this.service.get(url).pipe(map((response: any) => {
            return response;
        }));
    }
    public uploadFileHospitalDischarge(fileToUpload: File, item: IDtoDocument): Observable<IResult> {
        const formData = new FormData();
        formData.append('document', JSON.stringify(item));
        formData.append('files', fileToUpload);

        const url = `${this.requestUrl}api/InabilityDocuments/uploadFileHospitalDischarge/`;
        return this.service.post(url, formData).pipe(map((response: any) => {
            return response;
        }));
    }
    public downloadFileHospitalDischarge(referenceId: number, module: string, name: string): Observable<IResult> {

        const url = `${this.requestUrl}api/InabilityDocuments/downloadFileHospitalDischarge?referenceId=${referenceId}&module=${module}&name=${name}`;
        return this.service.get(url).pipe(map((response: any) => {
            return response;
        }));
    }
}
